import { useEffect, useState } from "react";

import { AudioWaveform, Blocks, ChevronDown, ChevronLeft, DownloadCloud, Fan, File, Flag, FolderCheck, Grid3X3, Heart, Info, LibraryBig, MessageCircle, Pencil, ShoppingCart, SquareDashedMousePointer, Video } from "lucide-react";
import CoursePageCardSubCourse from "../CoursePageDesign/CoursePageCardSubCourse";
import { coursePageObject } from "../CoursePageDesign/ExportCoursePageObject";
import PlayerPageCardMilestone from "./PlayerPageCardMilestone";

const PlayerSideBar =({courseId,subCourse,setChangeSubCourse,setCurrentItem,setShowLeftQueBar,playerCard1Object})=>{
  
 
    return(<> 
    <div className="sidebarCardOuter">
      <div style={{display:"flex",justifyContent:"space-between",margin:"5px"}}> 
        <div className="player-cardTitleFont playerSidebarEllipsis" 
         style={{fontSize:"15px",fontWeight:"800",margin:"0px",width:"220px",color:`${playerCard1Object?.milestone?.textColor?.color}`}}>
          {subCourse?.Name}</div> 
      <button onClick={()=>{setChangeSubCourse(true)}}  className="player-card__wishlist" style={{background:`${playerCard1Object?.milestone?.bgColor?.color}`,
border:` ${playerCard1Object?.milestone?.border?.borderWidth?.value+playerCard1Object?.milestone?.border?.borderWidth?.resolution} ${playerCard1Object?.milestone?.border?.borderType}  ${playerCard1Object?.milestone?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.milestone?.borderRadius?.topLeft?.value}${playerCard1Object?.milestone?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.milestone?.borderRadius?.topRight?.value}${playerCard1Object?.milestone?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.milestone?.borderRadius?.bottomLeft?.value}${playerCard1Object?.milestone?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.milestone?.borderRadius?.bottomRight?.value}${playerCard1Object?.milestone?.borderRadius?.bottomRight?.resolution}`,
              marginBottom:"2px",border:"0px",width:"40px",padding:"5px 3px"}} >
   <span className='player-cardButtonFont' style={{fontSize:"9px",color:`${playerCard1Object?.milestone?.iconColor?.color}`}}> Change</span></button>
</div>
 <div className="sidebarCardSection">
     <PlayerPageCardMilestone courseId={courseId} playerCard1Object={playerCard1Object} setCurrentItem={(v)=>{setCurrentItem(v)}}  subCourseIdBack={subCourse?.ID} subCourse={subCourse} />
 




    </div></div>


     <style>{`



     .playerSidebarEllipsis{
     position:relative;
     
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .sidebarLessonCardOuter{
    padding:10px;
    }
   
   .sidebarCardSectionInner{
    gap:10px;padding:5px; position:relative;
    display:flex;min-width:180px;
    justify-content:space-between;
    }.sidebarCardLessonInner{
    gap:10px; position:relative;margin-top:-20px;
    display:flex;min-width:180px;width:100%;
    justify-content:space-between;
    }

   
   
    .sidebarlessonCard{
    display:flex;
    justify-content:space-between;
    align-items:left;gap:10px;
    
    }
    .sidebarlessoImage{width:100px;}
    .sidebarlessonTitleSection,.sidebarlessonInnerSection{
    gap:10px;padding:5px; position:relative;
    display:flex;min-width:180px;width:100%;
    justify-content:left;
    align-items:left;}
.sidebarlessonInnerSectionThemeTwo{width:100%;}
.player-switchmutesmall {
    position: relative;padding:5px;padding-left:0px;
    display: inline-block;
    width: 77px;
    transform: scale(0.4);
    height: 25px;
    margin: 2px;
  }
  
  .player-switchmutesmall input {display:none;}
  
  .player-cardlfmutesmall {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color:${playerCard1Object?.lessonCard?.toggleColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
    -webkit-transition: .4s;
    transition: .4s;
  }
  .player-cardlfmutesmall:before {
    position: absolute;
    content: "";
    height: 30px;
    width: 30px;
    left: 0px;
    bottom: -4px;
    background: ${playerCard1Object?.lessonCard?.toggleColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.03);;border:7px solid #f9f9f9;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .player-cardlfmutesmall {
     background: ${playerCard1Object?.lessonCard?.toggleThumbColor?.color};box-shadow:0 7px 20px 0 rgba(144, 202, 249,0.3);
  }
  
  input:focus + .player-cardlfmutesmall {
    box-shadow: 0 0 1px #2196F3;
  }
  
  input:checked + .player-cardlfmutesmall:before {
    -webkit-transform: translateX(40px);
    -ms-transform: translateX(40px);
    transform: translateX(40px);
  }
  
  /* Rounded player-cardlfmutesmalls */
  .player-cardlfmutesmall.round {
    border-radius: 34px;
  }
  
  .player-cardlfmutesmall.round:before {
    border-radius: 50%;
  }
  
  .mutetitle{ position:relative; padding:5px;font-size:18px;top:-7px; font-weight:bold; }
  
  


    `}</style>
    </>)
}
export default PlayerSideBar;
